import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Loader2, TrendingUp, ChevronDown, Shield } from 'lucide-react';

const panel = {
  background: 'rgba(255,253,248,0.75)', border: '1px solid rgba(127,13,108,0.28)',
  borderRadius: 16, padding: '1.5rem', marginBottom: '1.5rem',
};

const Bar = ({ done, total }) => {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem', minWidth: 160 }}>
      <div style={{ flex: 1, height: 7, borderRadius: 999, background: 'rgba(127,13,108,0.12)' }}>
        <div style={{ width: `${pct}%`, height: '100%', borderRadius: 999,
          background: 'linear-gradient(90deg,#7F0D6C,#C79BBE)' }} />
      </div>
      <span style={{ fontSize: '.85rem', color: '#7c5f74', whiteSpace: 'nowrap' }}>{done}/{total}</span>
    </div>
  );
};

/** Who is moving through the trainings. Platinum+ work only — never their coaching history. */
export const PlatinumProgress = () => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState({});

  useEffect(() => {
    axios.get(`${API}/platinum-plus/admin/progress`)
      .then((r) => setData(r.data))
      .catch(() => setData({ courses: [], members: [] }));
  }, []);

  if (!data) {
    return <div style={{ ...panel, textAlign: 'center' }}><Loader2 className="w-6 h-6 animate-spin" style={{ margin: '0 auto', color: '#7F0D6C' }} /></div>;
  }

  return (
    <div style={panel} data-testid="platinum-progress">
      <h3 style={{ fontWeight: 700, fontSize: '1.3rem', color: '#5C0A4E', display: 'flex', alignItems: 'center', gap: '.5rem', marginBottom: '.25rem' }}>
        <TrendingUp className="w-5 h-5" style={{ color: '#7F0D6C' }} /> Training Progress
      </h3>
      <p style={{ color: '#7c5f74', fontSize: '.95rem', marginBottom: '1.25rem' }}>
        {data.member_count || 0} inside Platinum+ · {data.courses?.length || 0} training{data.courses?.length === 1 ? '' : 's'}.
        This is Platinum+ work only — nobody's coaching-program history is shown here.
      </p>

      {(!data.members || data.members.length === 0) ? (
        <p style={{ color: '#8a8172', fontStyle: 'italic' }}>Nobody has stepped into a training yet.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
          {data.members.map((m) => {
            const totalItems = (data.courses || []).reduce((s, c) => s + (c.items || 0), 0);
            const isOpen = open[m.user_id];
            return (
              <div key={m.user_id} style={{ background: 'rgba(127,13,108,0.05)', borderRadius: 12, padding: '.65rem .9rem' }}
                   data-testid={`platinum-progress-row-${m.user_id}`}>
                <button onClick={() => setOpen((o) => ({ ...o, [m.user_id]: !o[m.user_id] }))}
                  style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '1rem', textAlign: 'left' }}
                  data-testid={`platinum-progress-toggle-${m.user_id}`}>
                  <span style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ color: '#4a2340', fontWeight: 600 }}>{m.name}</span>
                    {m.is_platinum_admin && (
                      <span style={{ marginLeft: '.5rem', fontSize: '.75rem', color: '#7F0D6C', display: 'inline-flex', alignItems: 'center', gap: '.2rem' }}>
                        <Shield className="w-3 h-3" /> Platinum+ Admin
                      </span>
                    )}
                    <span style={{ display: 'block', fontSize: '.82rem', color: '#a09080' }}>{m.email}</span>
                  </span>
                  <Bar done={m.items_done} total={totalItems} />
                  <ChevronDown className="w-4 h-4" style={{ color: '#7F0D6C', transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }} />
                </button>

                {isOpen && (
                  <div style={{ marginTop: '.7rem', paddingTop: '.7rem', borderTop: '1px solid rgba(127,13,108,0.15)', display: 'flex', flexDirection: 'column', gap: '.5rem' }}>
                    {(m.courses || []).length === 0 && <span style={{ color: '#8a8172', fontSize: '.9rem' }}>No trainings yet.</span>}
                    {(m.courses || []).map((c) => (
                      <div key={c.course_id} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <span style={{ flex: 1, color: '#4a2340', fontSize: '.93rem' }}>
                          {c.title}
                          {c.completed && <span style={{ color: '#2f7a41', marginLeft: '.45rem', fontSize: '.8rem' }}>✓ complete</span>}
                        </span>
                        <span style={{ fontSize: '.8rem', color: '#7c5f74' }}>{c.sections_done}/{c.sections_total} sections</span>
                        <Bar done={c.items_done} total={c.items_total} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PlatinumProgress;
